import { gql } from '@apollo/client';
const SET_ORDER_MODEL_TO_NOT_READY = gql `
  mutation SetOrderModelToNotReady($orderModelId: ID!) {
    setOrderModelToNotReady(orderModelId: $orderModelId) {
      orderModel {
        id
      }
    }
  }
`;
export default SET_ORDER_MODEL_TO_NOT_READY;
